<template>
  <!-- Info card for small screen -->
  <v-col v-if="breakpointSmAndDown" cols="12" class="pa-0">
    <div class="fullWidth">
      <v-card color="primary" flat tile class="px-8 py-6 mt-n1">
        <v-row class="my-0">
          <v-col cols="12" class="pa-0">
            <!-- sub title -->
            <h4
              class="primary-font-color word-break-normal font-weight-regular"
            >
              {{ partner.BannerSubTitle }}
            </h4>
            <!-- title -->
            <h3 class="primary-font-color mb-2">
              {{ partner.BannerPromise }}
            </h3>
            <!-- description -->
            <div
              class="primary-font-color banner-description"
              v-html="partner.BannerDescription"
            ></div>
            <v-form ref="form" v-model="valid">
              <v-text-field
                :rules="emailRules"
                v-model="email"
                dark
                required
                :label="$translate('LOGIN_YOUR_EMAIL')"
                color="white"
              >
              </v-text-field>
            </v-form>

            <v-row justify="center" class="my-0">
              <v-btn
                depressed
                tile
                dark
                color="secondary"
                class="ma-0 text-lowercase font-weight-bold"
                @click="importInterestedUser"
              >
                {{ $translate('NEWS_LETTER_BUTTON') }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </div>
  </v-col>
</template>

<script>
import appConfig from '../../../config/app_config';
import doRequest from '@/api/dssRequest';

export default {
  name: 'BannerTextBlock',
  computed: {
    breakpointSmAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  data() {
    return {
      emailRules: [
        (v) => !!v || this.$translate('EMAIL_REQUIRED'),
        (v) => /.+@.+\..+/.test(v) || this.$translate('EMAIL_VALID'),
      ],
      email: '',
      partner: {},
      valid: null,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.partner = this.$store.getters['Account/partnerGroupDetails'];
    },
    importInterestedUser() {
      // check if email field is filled in
      if (!this.$refs.form.validate()) {
        return;
      }
      const payload = {
        Email: this.email,
        client_id: appConfig.Userlogin.clientSecret,
        TempUserId: this.$store.getters['auth/tmpUserId'],
      };
      doRequest(
        (response) => {
          // change the temp user id
          this.$store.commit('auth/setTmpUserId', response.data.UserId);
          this.$refs.form.reset();
          if (response.data.UserExisted) {
            window.EventBus.fire(
              'activateSnackBar',
              this.$translate('NEWSLETTER_ALERT_USEREXISTED')
            );
          } else {
            window.EventBus.fire(
              'activateSnackBar',
              this.$translate('NEWSLETTER_ALERT_SUCCESS')
            );
          }
        },
        () => {
          window.EventBus.fire(
            'activateSnackBar',
            this.$translate('NEWSLETTER_ALERT_ERROR')
          );
        },
        'importInterestedUser',
        this.$store.getters['Account/partnerGroupDetails'].AccountId,
        payload
      );
    },
  },
};
</script>
<style scoped lang="scss">
.fullWidth {
  width: 100vw;
  position: relative;
  left: calc(-50vw + 50%);
}
.banner-title {
  font-size: 25px;
  line-height: 30px;
}
.banner-subtitle {
  font-size: 18px;
  line-height: 22px;
}
.banner-description {
  font-size: 14px;
  line-height: 18px;
}
</style>
